import classNames from "classnames"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const MeteredElectricPowerPopover = ({ product, useNewTaxExperience }) => {
  const [expanded, setExpanded] = useState(false)
  const { presentmentCurrency } = useMarina()

  const taxDisplay = useNewTaxExperience
    ? product.combinedTaxRateDisplay
    : product.taxRate !== null
    ? `${(product.taxRate * 100).toFixed(2)}%`
    : null

  return (
    <div>
      <button
        type="button"
        className="cursor-pointer bg-transparent p-0 font-semibold text-blue-700"
        onClick={() => setExpanded(!expanded)}
      >
        Power{" "}
        <i
          className={classNames("fa-solid align-middle text-xxxs", {
            "fa-chevron-down": !expanded,
            "fa-chevron-up": expanded,
          })}
        />
      </button>
      {expanded && (
        <div>
          <span className="font-semibold">{product.name}</span>|{" "}
          {formatCurrencyFromMinorUnits({
            amount: product.pricePerUnit,
            currency: presentmentCurrency,
          })}
          /kWh
          {taxDisplay && <span>{`, ${taxDisplay} tax`}</span>}
        </div>
      )}
    </div>
  )
}

MeteredElectricPowerPopover.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    pricePerUnit: PropTypes.number.isRequired,
    taxRate: PropTypes.number,
    combinedTaxRateDisplay: PropTypes.string,
  }),
  useNewTaxExperience: PropTypes.bool.isRequired,
}

export default MeteredElectricPowerPopover
